export const genres: string[] = [
  "动作",
  "爱情",
  "科幻",
  "悬疑",
  "犯罪",
  "剧情",
  "古装",
  "奇幻",
  "冒险",
  "历史",
  "灾难",
  "都市",
  "政治",
  "武侠",
  "医疗",
  "青春",
  "校园",
  "惊悚",
];

export const regions: string[] = ["大陆", "欧美", "日韩"];

export const years: string[] = ["2025", "2024", "2023", "2022"];

export interface SortOption {
  value: string;
  label: string;
}

export const sortOptions: SortOption[] = [
  { value: "latest", label: "最新发布" },
  { value: "popular", label: "热度最高" },
  { value: "year", label: "年份最新" },
];

export interface TypeMeta {
  key: string;
  label: string;
  titleSuffix: string;
  description: string;
}

export const typeMetas: TypeMeta[] = [
  {
    key: "movie",
    label: "电影",
    titleSuffix: "精选电影",
    description: "汇集院线与网络最新电影资源，涵盖动作、科幻、悬疑、爱情等多种类型。",
  },
  {
    key: "tvshow",
    label: "电视剧",
    titleSuffix: "热播剧集",
    description: "精选最新电视剧与口碑剧集，国产剧、欧美剧、日韩剧一网打尽。",
  },
];